<nav #header *ngIf="renderMenu" class=" fixed-top headerStyle"
    [ngClass]="{'navbar2': this.companyParamsService.getFadeMenu()}"
    style="filter: drop-shadow(1px 1px 1px #6666664d);">
    <div style="background-color: #8bc244;" class="contactHeader">
        <div class="container green containerHeader">
            <div>
                <a style="font-weight:bolder; text-decoration: none; padding-right: 20px;"
                    href="https://www.camiadventures.com/ecuador-tours/tel:(593-2)%202682-200" target="_blank">
                    <i class="fa fa-phone" style="padding: 0 10px;"></i>
                    (593-2) 2682-200</a>
                <a href="mailto:info@camiadventures.com" target="_blank">
                    <i class="fa fa-envelope-o" style="padding: 0 10px;"></i>
                    info@camiadventures.com</a>

            </div>
            <div>
                <a href="https://www.facebook.com/pages/CamiAdventures-Travel-Specialist/807541119284083"><i
                        class="fa fa-facebook" style="padding: 0 10px;"></i></a>
                <a href="https://www.linkedin.com/company/camiadventures-travelspecialist/"><i class="fa fa-linkedin"
                        style="padding: 0 10px;"></i></a>
                <a href="https://twitter.com/camiadventures"><i class="fa fa-twitter" style="padding: 0 10px;"></i></a>
                <a href="https://www.youtube.com/channel/UCjIhxS7YRXXuSIOB3u7cX4g"><i class="fa fa-youtube"
                        style="padding: 0 10px;"></i></a>
                <a href="https://www.instagram.com/camiadventures/"><i class="fa fa-instagram"
                        style="padding: 0 10px;"></i></a>
            </div>
        </div>
    </div>
    <div #header1 class="container green containerMenu">
        <div *ngIf="companyParamsService.getHasLogoInformation()" class="tooltip fade show bs-tooltip-right"
            role="tooltip" id="tooltip164687" x-placement="right"
            style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(266px, 24px, 0px);">
            <div class="arrow" style="top: 8px;"></div>
            <div class="tooltip-inner">Your Logo Here</div>
        </div>
        <a *ngIf="!this.companyParamsService.getWebSite()" class="navbar-brand" target="_blank" class="navbar-brand"
            data-container=".green" data-toggle="tooltip" data-placement="right" title="Your Logo Here">
            <img src="assets/img/logo.jpg" height="50" alt="logo" class="brand-logo">
        </a>
        <a *ngIf="this.companyParamsService.getWebSite()" href="https://www.camiadventures.com/" class="navbar-brand"
            target="_blank">
            <input type="hidden" value="{{this.companyParamsService.getCompanyParams().logoFade}}" id="logoFade">
            <input type="hidden" value="{{this.companyParamsService.getCompanyParams().fadeMenu}}" id="fadeMenu">
            <img src="../assets/images/logos-header/ca.svg" alt="logo" class="brand-logo" style="height: 75px;">
        </a>
        <div class="containerMenu navbar-collapse collapse" style="width: inherit;">
            <ul class="navbar-nav menuContainer" style="width: inherit;">
                <li class="nav-item menuItem"><a href="https://www.camiadventures.com/galapagos-tours/"
                        target="_blank">Galapagos</a></li>
                <li class="nav-item menuItem"><a href="https://www.camiadventures.com/ecuador-tours/"
                        target="_blank">Ecuador</a></li>
                <li class="nav-item menuItem"><a href="https://www.camiadventures.com/amazon-tours/"
                        target="_blank">Amazon</a></li>
                <li class="nav-item menuItem"><a href="https://www.camiadventures.com/peru-tours/"
                        target="_blank">Peru</a></li>
                <li class="nav-item menuItem"><a href="https://www.camiadventures.com/airport-transfers/"
                        target="_blank">Transfers</a>
                </li>
                <li class="nav-item menuItem"><a href="https://www.camiadventures.com/about-us/" target="_blank">About
                        Us</a></li>
                <li class="nav-item menuItem"><a href="https://www.camiadventures.com/contact-us/"
                        target="_blank">Conctact Us</a></li>
            </ul>
            <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container">
                <app-heart-header></app-heart-header>
            </div>
        </div>
        <div class="container green containerHeader" style="justify-content: end; flex-direction: row!important;"
            class="responsiveHeader">
            <a class="menuButton" (click)="renderMenu()" href="javascript:void()" style="padding-right: 1em;">
                <i class="fa fa-bars fa-2x" style="padding-right: 10px;"></i>
            </a>
        </div>
    </div>
    <ul style="width: inherit; display: none;" class="menuContainer" [ngClass]="showMenu ? 'showMenu':''">
        <li class="nav-item menuItem"><a href="https://www.camiadventures.com/galapagos-tours/"
                target="_blank">GALAPAGOS</a></li>
        <li class="nav-item menuItem"><a href="https://www.camiadventures.com/ecuador-tours/"
                target="_blank">ECUADOR</a></li>
        <li class="nav-item menuItem"><a href="https://www.camiadventures.com/amazon-tours/" target="_blank">AMAZON</a>
        </li>
        <li class="nav-item menuItem"><a href="https://www.camiadventures.com/peru-tours/" target="_blank">PERU</a></li>
        <li class="nav-item menuItem"><a href="https://www.camiadventures.com/airport-transfers/"
                target="_blank">TRANSFERS</a>
        </li>
        <li class="nav-item menuItem"><a href="https://www.camiadventures.com/about-us/" target="_blank">ABOUT US</a>
        </li>
        <li class="nav-item menuItem"><a href="https://www.camiadventures.com/contact-us/" target="_blank">CONTACT
                US</a></li>
    </ul>
    <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container"
        [ngClass]="showMenu ? 'showMenu':''" style="width: inherit; display: none;">
        <app-heart-header></app-heart-header>
    </div>
</nav>